import './search.legacy.js';

import { mountApp } from '@/services/config.js';

import SearchApp from './SearchApp.vue';
import store from './store/index.js';

mountApp(SearchApp, '#app', [store]);

window.App.es6.shared.preload(['room']);
